import React, {Component} from 'react';
import {roundigFormat} from '../libs/utils/Operations';
import moment from 'moment';
import '../css/dataTables.css';


const renderTableBody = (headers, data, action, checkbox,editMode) => {
    let body: "";
    body = data.map((register, index) => {
       
        return (
            <tr key={index}>
                <td>{register.nombre || ""}</td>
                <td style={{textAlign:"center", width:50}}>
                    <input type="checkbox" 
                    style={{minWidth: '100%'}} 
                    id="cbox2" 
                    checked={!!checkbox.data.get(index)} 
                    onChange={(event) => checkbox.selectOne(index,event.target.checked)}/>
                </td>
            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action, checkbox,editMode) => {
    let header = "";
    let body = "";
    if (headers.length != 0) {
        header = <tr>
            {/* <td className="sticky-header table-header-yellow ">
                <input type="checkbox" style={{minWidth: '100%'}}
                 disabled={action===2 && !editMode}           
                       onChange={(event) => checkbox.selectAll(event.target.checked)}/>
            </td> */}
            <td className="sticky-header table-header-yellow" style={{textAlign:'center'}}>{headers[0].title}</td>
      
        </tr>;
    }

    body = renderTableBody(headers, data, action, checkbox,editMode);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{width: '100%'}}>
                <thead className="table-header">
                {header}
                </thead>
                <tbody>
                {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderTableName = (headers, data, action,checkbox,editMode) => {
  
    return renderTable(headers, data, action, checkbox,editMode);

}
